/** Routes that a contained guardian account may render in the client. */
export type GuardianLandingPath = "/guardian" | "/setup" | "/dashboard" | "/security-centre";

interface GuardianRoutingUser {
  aal: "AAL1" | "AAL2" | "AAL3";
  guardianOnly?: boolean;
}

/** Resolve a guardian-only user's contained home before their normal AAL landing. */
export function guardianLanding(user: GuardianRoutingUser): GuardianLandingPath {
  if (user.guardianOnly) return "/guardian";
  if (user.aal === "AAL1") return "/setup";
  if (user.aal === "AAL2") return "/dashboard";
  return "/security-centre";
}

/** Return whether a client path is part of the contained guardian experience. */
export function isGuardianOnlyClientPath(path: string): boolean {
  const pathname = path.split("?", 1)[0];
  if (!pathname.startsWith("/")) return false;

  return pathname === "/guardian"
    || pathname === "/auth"
    || pathname === "/auth/add-key"
    || /^\/onboarding\/guardian-invite\/[^/]+$/.test(pathname)
    || /^\/guardian-stepup\/[^/]+$/.test(pathname)
    || /^\/recovery-approval\/[^/]+$/.test(pathname)
    || /^\/i\/[^/]+$/.test(pathname)
    || /^\/onboarding\/counterparty-invite\/[^/]+$/.test(pathname);
}
